/** @format */

import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';
import { selectKillswitch } from '@pdp/data-access/state';

@Component({
	selector: 'pdp-attributes-components-base-attribute-label',
	standalone: true,
	imports: [CommonModule, HomefieldIconLibraryModule, HmfAlertBannerComponent],
	templateUrl: './base-attribute-label.component.html'
})
export class BaseAttributeLabelComponent {
	private readonly store = inject(Store);

	isAttributeErrorUpdatedEnabled = this.store.selectSignal(
		selectKillswitch('isAttributeErrorUpdatedEnabled')
	);

	attributeGroupName = input<string>();
	selectedAttributeValue = input<string>();
	// Whether the selected attribute should be shown if it's been input.
	selectedAttributeValueDisplayable = input<boolean>(true);
	errorMessage = input<string>();
	// Whether the error message should be shown if it's been input.
	errorMessageDisplayable = input<boolean>(true);
}
